import { CrowdHandlerWRState } from '../types/crowdhandler';

// Inline fallback countdown to ensure it always exists
const fallbackCountdown = {
    seconds: 0,
    minutes: 0,
    hours: 0,
    totalseconds: 999999999,
    onsale: null,
    inHours: null,
    sHours: "--",
    sMinutes: "--",
    sSeconds: "--"
};

export const updateCrowdHandlerWRState = (state: CrowdHandlerWRState, newData: Partial<CrowdHandlerWRState>): CrowdHandlerWRState => {
    // Exclude countdown and progress from newData - these should be set explicitly, not through merges
    const { countdown: _c, progress: _p, ...newDataWithoutExcluded } = newData;

    return {
        ...state,
        ...newDataWithoutExcluded,
        token: {
            ...state.token,
            ...(newData.token || {})
        },
        // Explicitly preserve countdown - never overwrite from merges
        // Fall back to inline defaults if state.countdown is somehow undefined
        countdown: state.countdown || fallbackCountdown,
        // Preserve progress - it's calculated separately in updateCHData
        progress: state.progress
    };
};
